module.exports = __webpack_public_path__ + "img/k-stamp-icon.6ec58b7e.png";